import clsx from "clsx";
import ButtonLayout from "../ButtonLayout";

export default function GreyButton(
    {
        children,
        className
    }
){
    return (
        <ButtonLayout
        className={clsx(
            "bg-zoeil-greyer text-white",
            className
            )}>
            {children}
        </ButtonLayout>
    )
}